export const mockData = {
  sectors: {
    hvac: {
      description: "iXus Group Limited provides comprehensive HVAC solutions for commercial and residential properties. Our expert team designs, installs, and maintains heating, ventilation, and air conditioning systems that ensure optimal comfort and energy efficiency. With cutting-edge technology and industry-leading expertise, we deliver climate control solutions that meet the highest standards of quality and performance.",
      images: [
        "https://images.unsplash.com/photo-1698479603408-1a66a6d9e80f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxIVkFDJTIwc3lzdGVtfGVufDB8fHx8MTc2NTIxOTI3M3ww&ixlib=rb-4.1.0&q=85",
        "https://images.unsplash.com/photo-1665826254140-28fa3d8738a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxIVkFDJTIwc3lzdGVtfGVufDB8fHx8MTc2NTIxOTI3M3ww&ixlib=rb-4.1.0&q=85",
        "https://images.pexels.com/photos/7534232/pexels-photo-7534232.jpeg"
      ],
      subsections: [
        {
          title: "Commercial HVAC Systems",
          slug: "commercial-hvac",
          shortDescription: "Comprehensive climate control solutions for large-scale commercial properties and industrial facilities.",
          detailedDescription: "Our commercial HVAC systems are designed to handle the complex requirements of large buildings, office complexes, retail spaces, and industrial facilities. We provide end-to-end solutions including system design, installation, commissioning, and ongoing maintenance. Our systems incorporate the latest energy-efficient technologies, smart controls, and monitoring capabilities to ensure optimal performance and cost-effectiveness. With proven expertise in handling projects of all sizes, we deliver reliable climate control that enhances occupant comfort while minimizing operational costs.",
          features: [
            "Custom system design and engineering",
            "Energy-efficient equipment selection",
            "Smart building integration",
            "Zone-based climate control",
            "Advanced air filtration systems",
            "Remote monitoring and diagnostics"
          ],
          benefits: [
            "Reduced energy consumption and operating costs",
            "Enhanced indoor air quality for healthier environments",
            "Improved occupant comfort and productivity",
            "Predictive maintenance reduces downtime",
            "Compliance with building regulations and standards",
            "Scalable solutions that grow with your business"
          ]
        },
        {
          title: "Residential HVAC Solutions",
          slug: "residential-hvac",
          shortDescription: "Home comfort systems designed for efficiency, reliability, and year-round climate control.",
          detailedDescription: "Transform your home into a haven of comfort with our residential HVAC solutions. We specialize in designing and installing heating and cooling systems tailored to the unique needs of your home. Whether you're building a new home, renovating, or upgrading your existing system, our experienced technicians ensure seamless installation and optimal performance. Our solutions incorporate the latest in energy-efficient technology, smart thermostats, and zoning capabilities to provide personalized comfort in every room while keeping energy costs low.",
          features: [
            "Whole-home comfort systems",
            "High-efficiency heat pumps",
            "Smart thermostat integration",
            "Ductless mini-split systems",
            "Air quality improvement solutions",
            "Programmable zoning options"
          ],
          benefits: [
            "Lower energy bills through efficient operation",
            "Consistent temperature throughout your home",
            "Improved air quality reduces allergens",
            "Quiet operation for peaceful living",
            "Extended equipment lifespan with proper maintenance",
            "Increased home value and appeal"
          ]
        },
        {
          title: "HVAC Maintenance & Service",
          slug: "hvac-maintenance",
          shortDescription: "Preventive maintenance programs that keep your systems running efficiently year-round.",
          detailedDescription: "Regular maintenance is essential for keeping HVAC systems operating at peak efficiency. Our comprehensive maintenance programs include scheduled inspections, cleaning, tune-ups, and performance optimization to prevent costly breakdowns and extend equipment life. Our certified technicians use advanced diagnostic tools to identify potential issues before they become major problems. We offer flexible maintenance plans tailored to your needs, whether residential or commercial, ensuring your comfort systems are always ready when you need them most.",
          features: [
            "Scheduled preventive maintenance",
            "24/7 emergency repair service",
            "System performance optimization",
            "Filter replacement and cleaning",
            "Refrigerant level checks",
            "Comprehensive system diagnostics"
          ],
          benefits: [
            "Prevents unexpected system failures",
            "Maintains manufacturer warranty compliance",
            "Improves energy efficiency and reduces costs",
            "Extends equipment lifespan significantly",
            "Priority service for maintenance customers",
            "Detailed service reports and recommendations"
          ]
        }
      ]
    },
    electrical: {
      description: "Our electrical services division delivers safe, reliable, and efficient electrical solutions for all types of projects. From new installations to upgrades and emergency repairs, our licensed electricians bring expertise and professionalism to every job. We stay current with the latest electrical codes and technologies to ensure your electrical systems are safe, efficient, and built to last.",
      images: [
        "https://images.unsplash.com/photo-1544724569-5f546fd6f2b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2FsJTIwcGFuZWx8ZW58MHx8fHwxNzY1MjE5Mjc5fDA&ixlib=rb-4.1.0&q=85",
        "https://images.unsplash.com/photo-1607631697491-61972eecf928?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxlbGVjdHJpY2FsJTIwcGFuZWx8ZW58MHx8fHwxNzY1MjE5Mjc5fDA&ixlib=rb-4.1.0&q=85",
        "https://images.pexels.com/photos/5767595/pexels-photo-5767595.jpeg"
      ],
      subsections: [
        {
          title: "Commercial Electrical Installation",
          slug: "commercial-electrical",
          shortDescription: "Complete electrical infrastructure for commercial buildings, offices, and industrial facilities.",
          detailedDescription: "Our commercial electrical installation services cover every aspect of electrical infrastructure for businesses of all sizes. We handle complex projects including power distribution systems, lighting design and installation, emergency backup systems, and data center power solutions. Our team works closely with architects, builders, and facility managers to deliver electrical systems that meet your operational needs while ensuring safety and code compliance. We understand the critical nature of commercial operations and deliver reliable, scalable electrical solutions that support your business growth.",
          features: [
            "Power distribution design and installation",
            "LED lighting systems and controls",
            "Emergency power and UPS systems",
            "Data center electrical infrastructure",
            "Electrical panel upgrades and expansion",
            "Building automation integration"
          ],
          benefits: [
            "Reduced energy costs with efficient systems",
            "Reliable power for uninterrupted operations",
            "Compliance with electrical codes and standards",
            "Scalable infrastructure for future growth",
            "Enhanced safety for employees and visitors",
            "Professional project management and coordination"
          ]
        },
        {
          title: "Residential Electrical Services",
          slug: "residential-electrical",
          shortDescription: "Safe and reliable electrical solutions for homes, from installations to repairs and upgrades.",
          detailedDescription: "We provide comprehensive residential electrical services to keep your home safe, functional, and modern. Whether you need new wiring for a home addition, panel upgrades, outlet installations, or troubleshooting electrical issues, our licensed electricians deliver quality workmanship and attention to detail. We specialize in smart home electrical integration, EV charging station installation, and energy-efficient lighting solutions. Our commitment to safety and customer satisfaction has made us the trusted choice for homeowners throughout the region.",
          features: [
            "Complete home rewiring services",
            "Electrical panel upgrades",
            "Smart home device installation",
            "EV charging station setup",
            "Lighting design and installation",
            "Surge protection systems"
          ],
          benefits: [
            "Enhanced home safety and security",
            "Increased property value",
            "Support for modern appliances and devices",
            "Energy-efficient lighting reduces costs",
            "Reliable power throughout your home",
            "Code-compliant installations"
          ]
        },
        {
          title: "Electrical Maintenance & Safety",
          slug: "electrical-maintenance",
          shortDescription: "Preventive maintenance and safety inspections to protect your property and ensure compliance.",
          detailedDescription: "Regular electrical maintenance is crucial for preventing hazards and ensuring system reliability. Our maintenance services include comprehensive electrical inspections, testing, thermal imaging, and preventive repairs. We identify potential issues before they cause disruptions or safety hazards. Our certified electricians follow strict safety protocols and use advanced diagnostic equipment to assess your electrical systems thoroughly. We provide detailed reports with recommendations for improvements, helping you maintain safe and efficient electrical infrastructure.",
          features: [
            "Comprehensive electrical inspections",
            "Thermal imaging diagnostics",
            "Circuit testing and analysis",
            "Safety compliance audits",
            "Emergency electrical repairs",
            "Code violation corrections"
          ],
          benefits: [
            "Prevents electrical fires and hazards",
            "Identifies issues before costly failures",
            "Ensures regulatory compliance",
            "Extends equipment lifespan",
            "Peace of mind with professional oversight",
            "Detailed documentation for insurance"
          ]
        }
      ]
    },
    doorAutomation: {
      description: "Enhance security, accessibility, and convenience with our advanced door automation solutions. We specialize in automatic door systems for commercial, industrial, and residential applications. From sleek sliding entrance doors to heavy-duty industrial overhead doors, our systems combine cutting-edge technology with robust engineering to deliver reliable, user-friendly access control.",
      images: [
        "https://images.unsplash.com/photo-1525570665650-76bb26af503d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxhdXRvbWF0aWMlMjBkb29yfGVufDB8fHx8MTc2NTIxOTI4NHww&ixlib=rb-4.1.0&q=85",
        "https://images.unsplash.com/photo-1735299738120-65271abbf035?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxhdXRvbWF0aWMlMjBkb29yfGVufDB8fHx8MTc2NTIxOTI4NHww&ixlib=rb-4.1.0&q=85",
        "https://images.pexels.com/photos/8554322/pexels-photo-8554322.jpeg"
      ],
      subsections: [
        {
          title: "Automatic Sliding Doors",
          slug: "sliding-doors",
          shortDescription: "Modern automatic sliding door systems for retail, healthcare, and commercial entrances.",
          detailedDescription: "Our automatic sliding door systems provide welcoming, accessible entrances for high-traffic commercial environments. We install and service a wide range of sliding door configurations including single-slide, bi-parting, telescoping, and curved designs. Each system features advanced motion sensors, safety mechanisms, and durable components engineered for millions of operation cycles. Our solutions integrate seamlessly with building access control systems and can be customized with various glass types, finishes, and performance specifications to match your architectural vision while ensuring ADA compliance.",
          features: [
            "Multiple configuration options",
            "Advanced sensor technology",
            "Safety beam protection",
            "Emergency breakout capability",
            "Low-energy operators",
            "Access control integration"
          ],
          benefits: [
            "Improved accessibility for all visitors",
            "Enhanced building aesthetics",
            "Energy efficiency with climate control",
            "Reduced maintenance costs",
            "Increased traffic flow capacity",
            "ADA and building code compliance"
          ]
        },
        {
          title: "Industrial Door Systems",
          slug: "industrial-doors",
          shortDescription: "Heavy-duty automatic door solutions for warehouses, factories, and loading docks.",
          detailedDescription: "Our industrial door automation systems are built to withstand the demanding environments of warehouses, manufacturing facilities, and distribution centers. We provide high-speed roll-up doors, sectional overhead doors, and specialized cold storage doors with powerful operators and robust safety systems. These doors are engineered for high-cycle operations, featuring rapid opening and closing speeds to improve workflow efficiency while maintaining security and climate control. Advanced safety features including photo-eyes, reversing edges, and emergency stop controls ensure operator safety in busy industrial settings.",
          features: [
            "High-speed operation capability",
            "Heavy-duty construction",
            "Insulated door options",
            "Weather-sealing technology",
            "Variable frequency drives",
            "Integrated safety systems"
          ],
          benefits: [
            "Increased operational efficiency",
            "Reduced energy loss in climate-controlled spaces",
            "Enhanced workplace safety",
            "Minimal downtime with reliable operation",
            "Improved security for valuable assets",
            "Lower maintenance costs over time"
          ]
        },
        {
          title: "Access Control Integration",
          slug: "access-control",
          shortDescription: "Smart door automation integrated with modern access control and security systems.",
          detailedDescription: "Take your building security to the next level with our integrated door automation and access control solutions. We seamlessly connect automatic doors with card readers, biometric scanners, intercoms, and video surveillance systems to create comprehensive security management. Our systems support multi-level access permissions, time-based scheduling, and detailed activity logging for complete control over who enters your facility and when. Cloud-based management platforms provide real-time monitoring and remote control capabilities, allowing facility managers to oversee multiple locations from anywhere.",
          features: [
            "Card and biometric reader integration",
            "Video intercom systems",
            "Cloud-based management",
            "Multi-site control capability",
            "Real-time activity monitoring",
            "Visitor management integration"
          ],
          benefits: [
            "Enhanced facility security",
            "Detailed access audit trails",
            "Remote management capabilities",
            "Reduced security personnel needs",
            "Improved visitor experience",
            "Compliance with security regulations"
          ]
        }
      ]
    }
  },
  testimonials: [
    {
      name: "Sarah Mitchell",
      position: "Facilities Manager",
      company: "TechCorp Industries",
      feedback: "iXus Group transformed our outdated HVAC system into a modern, energy-efficient solution. The professionalism and expertise demonstrated throughout the project were exceptional. We've seen a 30% reduction in energy costs!"
    },
    {
      name: "James Robertson",
      position: "Property Developer",
      company: "Robertson Developments Ltd",
      feedback: "We've worked with iXus on multiple commercial projects. Their electrical team is always reliable, professional, and delivers on time. The quality of work is consistently outstanding, and they handle complex installations with ease."
    },
    {
      name: "Emma Thompson",
      position: "Retail Operations Director",
      company: "Greenfield Retail Group",
      feedback: "The automatic door systems installed by iXus have significantly improved our customer experience. The doors operate flawlessly, and their maintenance service is prompt and professional. Highly recommended!"
    }
  ]
};
